/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosports2ColumnImagesViewProps } from '../../../modules/hosports-2-column-images/./hosports-2-column-images';
import FullWidthImage from '../../../baseComponents/full-width-image/./full-width-image';
import GridStructure from '../../../baseComponents/grid-structure/./grid-structure';
import ScrollFadeIn from '../../../baseComponents/scroll-fade/./scroll-fade';

export default (props: IHosports2ColumnImagesViewProps) => {
  let config = props.config;

  return (
    <ScrollFadeIn>
      <div className="site-gutter">
        <GridStructure
          columns={2}>
          <FullWidthImage
            image={config.image1 ? config.image1.src : undefined}
            height={config.height}
          />
          <FullWidthImage
            image={config.image2 ? config.image2.src : undefined}
            height={config.height}
          />
        </GridStructure>
      </div>
    </ScrollFadeIn>
  );
};
